import { ReflectorBody } from '@/infrastructure/reflector/ReflectorBody';
import { arrayFirstItemOrNull } from '@/platform/core/ArrayExtensions';
import { Body } from './Body';
import { ReflectorBodyIntegration } from '@/infrastructure/reflector/ReflectorBodyIntegration';
import { PlatformIntegration } from '@/platform/PlatformIntegration';

class BodyPresenter extends ReflectorBodyIntegration {
	public async retrieve(id: string): Promise<Body | null> {
		const authorization =
			await PlatformIntegration.instance.authorizer.authorizeBodyQuery();

		const result = await this.sendGet<ReflectorBody>(
			'/data/bodies/any/details/',
			`ids-${id}`,
			authorization,
		);
		const bodies = this.reconstituteAll(result);

		return arrayFirstItemOrNull(bodies);
	}

	public async retrieveAll(): Promise<readonly Body[]> {
		const authorization =
			await PlatformIntegration.instance.authorizer.authorizeBodyQuery();
		const result = new Array<ReflectorBody>();

		const length = 150;
		let offset = 0;
		let partialResult: readonly ReflectorBody[] = [];

		do {
			partialResult = await this.sendGet<ReflectorBody>(
				'/data/bodies/any/details/',
				null,
				authorization,
				offset,
				length,
			);
			offset += partialResult.length;

			result.push(...partialResult);
		} while (partialResult.length === length);

		return this.reconstituteAll(result);
	}
}

const instance = new BodyPresenter();
export { instance as BodyPresenter };
